import { useMemo } from 'react'

import { hexShade } from 'utils/color'

const useHexShade = (percentage, hexColor) =>
  useMemo(() => hexShade(percentage, hexColor), [percentage, hexColor])

export default useHexShade
